import React, { Component } from "react";
import i18n from '../../i18n';
import Select from "react-select";
import { Button, Modal } from "react-bootstrap";
import { FaEye } from "react-icons/fa";
import api from "../../services/api";


class ExportPrestadoresPDF extends Component {
  constructor(props) {
    super(props);
    this.state = {
      columns: [
        { value: "id", label: "ID" },
        { value: "nome", label: "Nome" },
        { value: "cpf_cnpj", label: "CPF/CNPJ" },
        { value: "email", label: "Email" },
        { value: "razao_social", label: "Razão Social" },
        { value: "nome_fantasia", label: "Nome Fantasia" },
        { value: "tipo_pessoa", label: "Tipo de Pessoa" },
        { value: "telefone", label: "Telefone" },
        { value: "celular", label: "Celular" },
        { value: "endereco", label: "Endereço" },
        { value: "cidade", label: "Cidade" },
        { value: "uf", label: "UF" },
        { value: "programa__nome", label: "Programa" },
        { value: "cliente__nome", label: "Cliente" },
        {
          value: "categoria_multiprofissional__nome",
          label: "Categoria Multiprofissional",
        },
        { value: "data_criacao", label: "Data de Criação" },
        { value: "mentor", label: "Mentor" },
      ],
      selectedColumns: [
        { value: "id", label: "ID" },
        { value: "nome", label: "Nome" },
        { value: "cpf_cnpj", label: "CPF/CNPJ" },
        { value: "email", label: "Email" },
        { value: "razao_social", label: "Razão Social" },
        { value: "nome_fantasia", label: "Nome Fantasia" },
        { value: "tipo_pessoa", label: "Tipo de Pessoa" },
        { value: "programa__nome", label: "Programa" },
        { value: "data_criacao", label: "Data de Criação" },
      ],
      showModal: false,
      allFieldsChecked: false,
    };
  }

  handleAllFieldsToggle = () => {
    const { allFieldsChecked, columns } = this.state;
    this.setState({
      allFieldsChecked: !allFieldsChecked,
      selectedColumns: !allFieldsChecked ? columns : [],
    });
  };

  toggleModal = () => {
    this.setState((prevState) => ({ showModal: !prevState.showModal }));
  };

  handleExportPDF = () => {
    const { selectedColumns } = this.state;

    if (selectedColumns.length === 0) {
      alert("Por favor, selecione ao menos uma coluna.");
      return;
    }

    const selectedValues = selectedColumns.map((col) => col.value);

    api
      .post(
        "/export-prestadores-pdf/", // Endpoint da API para prestadores
        { columns: selectedValues },
        { responseType: "blob" }
      )
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "relatorio_prestadores.pdf");
        document.body.appendChild(link);
        link.click();
        this.toggleModal();
      })
      .catch((error) => {
        console.error("Erro ao exportar PDF:", error);
      });
  };

  render() {
    const { showModal, columns, selectedColumns } = this.state;

    return (
      <>
        <Button variant="light" size="sm" onClick={this.toggleModal}>
          <FaEye /> {i18n.t('common:export.pdf')}
        </Button>

        <Modal show={showModal} onHide={this.toggleModal} centered>
          <Modal.Header closeButton>
            <Modal.Title>{i18n.t('common:export.pdf')}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p>{i18n.t('common:export.selectColumns')}</p>
            <div className="mb-3">
              <input
                type="checkbox"
                id="all-fields"
                checked={this.state.allFieldsChecked}
                onChange={this.handleAllFieldsToggle}
              />
              <label htmlFor="all-fields" className="ms-2">
                {i18n.t('common:export.allFields')}
              </label>
            </div>
            <Select
              options={columns}
              isMulti
              onChange={(selected) =>
                this.setState({
                  selectedColumns: selected,
                  allFieldsChecked: false,
                })
              }
              value={selectedColumns}
              placeholder={i18n.t('common:export.columnsPlaceholder')}
              className="mb-3"
            />
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.toggleModal}>
              {i18n.t('common:button.cancel')}
            </Button>
            <Button variant="primary" onClick={this.handleExportPDF}>
              {i18n.t('common:export.pdf')}
            </Button>
          </Modal.Footer>
        </Modal>
      </>
    );
  }
}

export default ExportPrestadoresPDF;